export enum MESSAGES {
  ARTICLE = ':ARTICLE',
  BOT_MESSAGE = ':BOT_MESSAGE',
  AI_ARTICLE_ANSWER = ':AI_ARTICLE_ANSWER',
  ANSWER_GENERATION = ':ANSWER_GENERATION',
  TITLE_BOT_MESSAGE = ':TITLE_BOT_MESSAGE',
  BOT_TYPING = ':BOT_TYPING',
  USER_MESSAGE = ':USER_MESSAGE',
  BUTTONS = ':BUTTONS',
  BUTTONS_VERTICAL = ':BUTTONS_VERTICAL',
  PHONE = ':PHONE_SELECTOR',
  VIDEO = ':VIDEO',
  IMAGE = ':IMAGE',
  SKILL_SUCCESS_MESSAGE = ':SKILL_SUCCESS_MESSAGE',
  CONVERSATION_FEEDBACK = ':CONVERSATION_FEEDBACK',
  CARA_ENTRY_POINT = ':CARA_ENTRY_POINT',
  CARA_CALL_ENDED = ':CARA_CALL_ENDED',
  SURVEY = ':SURVEY',
  // selectors
  CATEGORY = ':CATEGORY',
  SITE_SELECTOR = ':SITE_SELECTOR',
  DOMAIN_SELECTOR = ':DOMAIN_SELECTOR',
  ARTICLE_SELECTOR = ':ARTICLE_SELECTOR',
  INVOICE_SELECTOR = ':INVOICE_SELECTOR',
  LOGIN_SELECTOR = ':LOGIN_SELECTOR',
  USER_ACCOUNTS_SELECTOR = ':USER_ACCOUNTS_SELECTOR',
  WHITELABEL_SELECTOR = ':WHITELABEL_SELECTOR',
  // It's a types for messages in chat
  CHANGE_MODE = ':CHANGE_MODE',
  AGENT_STATUS = ':AGENT_STATUS',
  AGENT_MESSAGE = ':AGENT_MESSAGE',
  CHAT_TRANSFERRED = ':CHAT_TRANSFERRED',
  WAITING_FOR_AGENT = ':WAITING_FOR_AGENT',
  CONNECTING_AGENT = ':CONNECTING_AGENT',
}

export enum SELECTOR_TYPE_RPC {
  ':PHONE_SELECTOR' = 'PHONE_SELECTOR',
  ':ARTICLE_SELECTOR' = 'ARTICLE_SELECTOR',
  ':INVOICE_SELECTOR' = 'INVOICE_SELECTOR',
  ':DOMAIN_SELECTOR' = 'DOMAIN_SELECTOR',
  ':SITE_SELECTOR' = 'SITE_SELECTOR',
  ':USER_ACCOUNTS_SELECTOR' = 'USER_ACCOUNTS_SELECTOR',
  ':WHITELABEL_SELECTOR' = 'WHITELABEL_SELECTOR',
}

export enum SELECTOR_TYPE_TO_ITEM_NAME {
  ':PHONE_SELECTOR' = 'phoneSelector',
  ':ARTICLE_SELECTOR' = 'articleSelector',
  ':INVOICE_SELECTOR' = 'invoiceSelector',
  ':DOMAIN_SELECTOR' = 'domainSelector',
  ':SITE_SELECTOR' = 'siteSelector',
  ':USER_ACCOUNTS_SELECTOR' = 'userAccountsSelector',
  ':WHITELABEL_SELECTOR' = 'whitelabelSelector',
}

// It's a types that coming from duplexer
export enum EVENTS_LIVE_CHAT {
  AGENT_REPLIED = 'AGENT_REPLIED',
  AGENT_JOINED = 'AGENT_JOINED',
  AGENT_LEFT = 'AGENT_LEFT',
  CHAT_TRANSFERRED = 'CHAT_TRANSFERRED',
  WAITING_FOR_AGENT = 'WAITING_FOR_AGENT',
}

export enum INTERNAL_MESSAGE {
  START = ':START',
  REDIRECT = ':REDIRECT',
  COLLAPSE_WIDGET = ':COLLAPSE_WIDGET',
  CHANGE_RESTART_CHAT_PARAMETERS = ':CHANGE_RESTART_CHAT_PARAMETERS',
}
